import { NgModule } from '@angular/core';
import { ShopComponent } from './shop.component';
import { ShopDetailComponent } from './shop-detail.component';
import { SharedModule } from '../shared/shared.module';
import { ShopService } from './shop.service';
import { HttpClient } from '@angular/common/http';
import { PaginationComponent } from './pagination.component';

@NgModule({
  declarations: [
    ShopComponent,
    ShopDetailComponent,
    PaginationComponent
  ],
  exports: [
    ShopComponent,
    ShopDetailComponent,
    PaginationComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    ShopService,
    HttpClient,
    { provide: 'WINDOW', useFactory: getWindow }
  ]
})

export class ShopModule {}


export function getWindow() {
  return (typeof window !== 'undefined') ? window : null;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/shop/shop.module.ts